import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_dashboard/layout/core'
import { FooterListWrapper } from './FooterComponent'
import { useIntl } from 'react-intl'

const FooterPage = () => {
  const intl = useIntl()

  const FooterBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'FOOTER_PAGE.BREADCRUMB' }),
      path: '/apps/footer-management/footer',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='footer'
          element={
            <>
              <PageTitle breadcrumbs={FooterBreadcrumbs}>
                {intl.formatMessage({ id: 'FOOTER_PAGE.TITLE' })}
              </PageTitle>
              <FooterListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/footer-management/footer' />} />
    </Routes>
  )
}

export default FooterPage
